module.exports = __webpack_public_path__ + "img/layout.4166a9f0.svg";